import { z } from "zod";

import { EProgramApplianceCategory } from "@/domains/v4b/program/program.types";

export enum EMetaModeGroup {
  HEATER_MODE = "HEATER_MODE",
  ON_OFF_MODE = "ON_OFF_MODE",
  ON_OFF_TEMP_MODE = "ON_OFF_TEMP_MODE",
  BOOKABLE_SPACE = "BOOKABLE_SPACE",
}

export const DEFAULT_DISPLAYED_APPLIANCE_CATEGORIES: EProgramApplianceCategory[] = [EProgramApplianceCategory.HEATER];

export const DEFAULT_BLACKLISTED_PROGRAMS_APPLIANCE_CATEGORIES: EProgramApplianceCategory[] = [
  EProgramApplianceCategory.BOOKABLE_SPACE,
];

export const applianceCategoryMode: Record<EProgramApplianceCategory, EMetaModeGroup> = {
  [EProgramApplianceCategory.HEATER]: EMetaModeGroup.HEATER_MODE,
  [EProgramApplianceCategory.BOOKABLE_SPACE]: EMetaModeGroup.BOOKABLE_SPACE,

  // ON/OFF appliances
  [EProgramApplianceCategory.AC_UNIT_NON_INFRARED]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.AIR_HANDLING_UNIT]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.BOILER]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.CHARGING_STATION]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.CHILLER]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.CHILLER_FOOD_GRADE]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.GENERATOR_SET]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.HEATER_STORAGE]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.HEATER_UNIT]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.HEATING_FLOOR]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.HEAT_PUMP]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.HEAT_PUMP_DHW]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.HEAT_PUMP_WITH_TEMPERATURE]: EMetaModeGroup.ON_OFF_TEMP_MODE,
  [EProgramApplianceCategory.POOL_HEATER]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.PUMP_MOTOR]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.RADIANT_CEILING_PANEL]: EMetaModeGroup.ON_OFF_MODE,
  [EProgramApplianceCategory.WATER_HEATER]: EMetaModeGroup.ON_OFF_MODE,
};

export const activateProgramRequestSchema = z.object({
  isActive: z.boolean(),
});

export type TActivateProgramRequest = z.infer<typeof activateProgramRequestSchema>;
